import { AiBrief } from '../../../types/metrics'
import { AppMarkdownViewer } from '../../atoms/AppMarkdownViewer/AppMarkdownViewer'
import InfoTooltip from '../../atoms/InfoTooltip'

const COHORT_OVERVIEW_TOOLTIP =
  'AI-generated summary of review activity and notable signals across the cohort for the selected time range.'

type Props = {
  brief: AiBrief
  timeRangeLabel: string
}

const AiBriefCard = ({ brief, timeRangeLabel }: Props): JSX.Element => (
  <div className="rounded-2xl bg-white p-10 shadow-[0_0_20px_5px_rgba(0,0,0,0.08)]">
    <div className="mb-4 flex flex-wrap items-center gap-2">
      <h3 className="text-2xl font-bold text-dark-blue">Cohort overview — {timeRangeLabel}</h3>
      <InfoTooltip text={COHORT_OVERVIEW_TOOLTIP} />
      {brief.aiGenerated && (
        <span className="rounded-full bg-pale-blue px-2 py-0.5 text-xl font-medium text-light-blue">AI summary</span>
      )}
    </div>
    <AppMarkdownViewer markdown={brief.brief} className="text-xl leading-8 text-blue-gray" />
  </div>
)

export const AiBriefSkeleton = ({ timeRangeLabel }: { timeRangeLabel: string }): JSX.Element => (
  <div className="rounded-2xl bg-white p-10 shadow-[0_0_20px_5px_rgba(0,0,0,0.08)]">
    <div className="mb-4 flex flex-wrap items-center gap-2">
      <h3 className="text-2xl font-bold text-dark-blue">Cohort overview — {timeRangeLabel}</h3>
      <InfoTooltip text={COHORT_OVERVIEW_TOOLTIP} />
      <span className="rounded-full bg-pale-blue px-2 py-0.5 text-xl font-medium text-light-blue">
        Generating summary…
      </span>
    </div>
    <div className="space-y-3 animate-pulse">
      <div className="h-4 rounded bg-soft-gray" />
      <div className="h-4 rounded bg-soft-gray w-5/6" />
      <div className="h-4 rounded bg-soft-gray" />
      <div className="h-4 rounded bg-soft-gray w-4/5" />
      <div className="mt-4 h-4 rounded bg-soft-gray" />
      <div className="h-4 rounded bg-soft-gray w-5/6" />
      <div className="h-4 rounded bg-soft-gray w-3/4" />
    </div>
  </div>
)

export default AiBriefCard
